export const subtitles = {
    "1": {
        "startTime": 0.03,
        "endTime": 2.38,
        "transcript": "...piqatallratnek.",
        "translation": "...what they were going to do."
    },
    "2": {
        "startTime": 2.39,
        "endTime": 6.65,
        "transcript": "Piaqlua-llu, \"Ila-i, TV-ni-wa wii pugngailngua.\"",
        "translation": "And I'd say, \"Oh no, I won't appear on TV.\""
    },
    "3": {
        "startTime": 6.8100000000000005,
        "endTime": 14.77,
        "transcript": "Cunawa-m' makut tangerrluki ernemteńi arenqiatuq tua-i.",
        "translation": "It turned out that looking at these [people] in our day, it's distressing."
    },
    "4": {
        "startTime": 14.785,
        "endTime": 19.265,
        "transcript": "Qaneqsaunata uitakumta, we won't done anything.",
        "translation": "If we stay without saying anything, we won't [accomplish] anything."
    },
    "5": {
        "startTime": 19.322,
        "endTime": 25.161,
        "transcript": "Apcugciqamken. Apciiqamken wall'u ayainantemteńi qanrutniaramken.",
        "translation": "I will want to ask you questions. I will ask you, or as we go, I'll tell you."
    },
    "6": {
        "startTime": 25.176,
        "endTime": 32.076,
        "transcript": "Waten maa-i qanelriaten ak'a avani cainata (Ii-i, ii-i.) cainata [?]. (Arrsauluta.)",
        "translation": "You said that a long time ago, we didn't have any [Western] things (Yes, yes.) didn't have anything [?]. (We were destitute.)"
    },
    "7": {
        "startTime": 32.083,
        "endTime": 38.723,
        "transcript": "Qaillun ilakutelput iciw' ilakutellriani",
        "translation": "How is our relations, you know, we who are related to each other"
    },
    "8": {
        "startTime": 39.57,
        "endTime": 46.27,
        "transcript": "Tamatum Kassaurtessiyaallemta una ilakutelput agtuumaa? Tamakut wani...",
        "translation": "How is has us being too Westernized affected our relations? Those..."
    },
    "9": {
        "startTime": 46.286,
        "endTime": 48.946,
        "transcript": "Are we rolling? (Yaa.) Okay.",
        "translation": "Are we rolling? (Yes.) Okay."
    },
    "10": {
        "startTime": 49.508,
        "endTime": 51.968,
        "transcript": "Qaillun atak' apqerlaku?",
        "translation": "Let's see, how shall I say it?"
    },
    "11": {
        "startTime": 51.97,
        "endTime": 60.77,
        "transcript": "Tua-i-wa murilkellerpeni ilakutelput-qaa, ilat wani family-t ukut ilakutellrat",
        "translation": "In your observation, are our relations, how these families interact with [cultural] relations"
    },
    "12": {
        "startTime": 61.803,
        "endTime": 66.813,
        "transcript": "Asiinaku agtuumaat tukuurtessiyaallrata, wall'u-qaa qaillun?",
        "translation": "Is their abundance of wealth negatively affecting it, or how?"
    },
    "13": {
        "startTime": 67.284,
        "endTime": 74.594,
        "transcript": "Kiingan tua-i murilkellerpenek. Umyuaqeksailkuvgu-llu qanrutkenrilngerpegu canrituq.",
        "translation": "Just your observation. And if you haven't thought about it, it's okay if you don't speak on it."
    },
    "14": {
        "startTime": 74.6,
        "endTime": 77.28,
        "transcript": "Ayuquciipakar.",
        "translation": "I have no idea."
    },
    "15": {
        "startTime": 78.607,
        "endTime": 81.157,
        "transcript": "What was I saying again?",
        "translation": "What was I saying again?"
    },
    "16": {
        "startTime": 84.716,
        "endTime": 89.826,
        "transcript": "Oh yaa, cali tua-i callugtellerkamek enemi...",
        "translation": "Oh yes, also [?to diligentely do things] in the house..."
    },
    "17": {
        "startTime": 89.829,
        "endTime": 92.159,
        "transcript": "(Paniit uitaviit.) Oh, paniit. (Yaa.)",
        "translation": "(Daughter's places.) Oh, daughters. (Yes.)"
    },
    "18": {
        "startTime": 92.16,
        "endTime": 99.53,
        "transcript": "Yaa, tua-i-llu waten-am qantullruata au͡gkut wani eneqeraqluki piunga:",
        "translation": "Yes, then because those people back then used to say this, I remember:"
    },
    "19": {
        "startTime": 99.543,
        "endTime": 107.233,
        "transcript": "Arnat-gguq irniamta wangkuta aanaulriani cauralput ayuqeliyugngaa.",
        "translation": "Our female children can copy what we mothers work on."
    },
    "20": {
        "startTime": 107.452,
        "endTime": 109.392,
        "transcript": "Piciuguq.",
        "translation": "It's true."
    },
    "21": {
        "startTime": 109.649,
        "endTime": 119.289,
        "transcript": "Mingquratukuma panima ayuqeliyugngaat mingqaqluteng-llu.",
        "translation": "If I keep sewing, my daughters can copy it, and sew."
    },
    "22": {
        "startTime": 119.471,
        "endTime": 124.121,
        "transcript": "Tau͡gaam-wa mat'um nalliini elitnauq man'a cavagta.",
        "translation": "But these days, this schooling is such a conundrum."
    },
    "23": {
        "startTime": 126.244,
        "endTime": 132.972,
        "transcript": "Tua-i nanrarngaitanka irnianka. Cuqkuuryugngaanka cuqyutekluki.",
        "translation": "I will not praise my children. I can use them as examples."
    },
    "24": {
        "startTime": 133.234,
        "endTime": 142.024,
        "transcript": "Ataucimek-llu maa-i irniangqertua college-aalalriamek. Allrakut-am tua-i maa-i amllerilriit.",
        "translation": "I also have one child now who goes to college. It's been many years now."
    },
    "25": {
        "startTime": 142.168,
        "endTime": 145.508,
        "transcript": "Apqiitnek drop out-araqluni.",
        "translation": "[S]he would drop out, as they call it."
    },
    "26": {
        "startTime": 146.358,
        "endTime": 150.568,
        "transcript": "Tang makut-wa qaill' piat?",
        "translation": "Look at these, what's going on with them?"
    },
    "27": {
        "startTime": 151.37,
        "endTime": 162.39,
        "transcript": "Makumek-llu tang caliyaramek maani yuuluni nalluluni.",
        "translation": "And, you see, [s]he's living without knowing how to work."
    },
    "28": {
        "startTime": 163.023,
        "endTime": 168.143,
        "transcript": "Caliyuyuunani-ll', naaqiq tau͡gaam.",
        "translation": "And [s]he never wants to work, only read."
    },
    "29": {
        "startTime": 169.509,
        "endTime": 174.309,
        "transcript": "Tua-llu cali cuqku'urluku, cuqyutkaqluki-w' canrilnguq.",
        "translation": "Then also as an example, it's okay to use them as examples."
    },
    "30": {
        "startTime": 174.733,
        "endTime": 180.403,
        "transcript": "Atauciq irniaqa elitnaunermek qessayulallruuq.",
        "translation": "One of my children would be disinclined to go to school."
    },
    "31": {
        "startTime": 180.416,
        "endTime": 188.496,
        "transcript": "Cayunqepiaq. Caliyunqeggluni boy-aq, outside work.",
        "translation": "He loved being active. The boy liked to work, outside work."
    },
    "32": {
        "startTime": 189.897,
        "endTime": 195.607,
        "transcript": "Nallunritaqa cikuciyunqektallrulria mikluni.",
        "translation": "I know that he liked to pack ice when he was small."
    },
    "33": {
        "startTime": 195.61,
        "endTime": 199.97,
        "transcript": "Mer'icecuunii. Qessaitpiaq.",
        "translation": "He never let me go without water. He was never lazy."
    },
    "34": {
        "startTime": 200.211,
        "endTime": 206.901,
        "transcript": "Wiinga-w' pisqurqeka iciw' kiingan pistek'lallruamku.",
        "translation": "I would keep telling him to, you know, because he was my only provider."
    },
    "35": {
        "startTime": 207.448,
        "endTime": 218.088,
        "transcript": "Mat'um nalliini tangrraqa caliyaramek qagaani-llu nallunritqapiarluni tauna.",
        "translation": "I see him these days, knowing really well how to work, outside too."
    },
    "36": {
        "startTime": 218.627,
        "endTime": 232.188,
        "transcript": "Ayagmek, angutngurrluni utaqaurpek'nani ayagmek tau͡gaam piuralria apqiitnek Kass'at train-arciqliniuq ellminek.",
        "translation": "From the start, without waiting to become a man, but one who keeps doing it from the start will train himself as they say in English."
    },
    "37": {
        "startTime": 232.539,
        "endTime": 237.459,
        "transcript": "Taukun cali tua-i cuqyuteksugngaaqa yumkun ataucikun.",
        "translation": "I can also make an example of that with one of my children."
    },
    "38": {
        "startTime": 237.622,
        "endTime": 244.612,
        "transcript": "Mat'um nalliini youngest, irniarugama youngest.",
        "translation": "Now, he's the youngest, the youngest out of my many children."
    },
    "39": {
        "startTime": 246.987,
        "endTime": 250.967,
        "transcript": "Cacetuqutek'la'rqa ellami caarkanek.",
        "translation": "I depend on him to do outside chores."
    },
    "40": {
        "startTime": 251.53,
        "endTime": 257.33,
        "transcript": "Calinaurtuq tuar taqneq, nallunritqapiarluni.",
        "translation": "He would work like an adult, knowing really well."
    },
    "41": {
        "startTime": 259.247,
        "endTime": 260.957,
        "transcript": "Tua-i tua-i.",
        "translation": "There you have it."
    },
    "42": {
        "startTime": 260.966,
        "endTime": 264.846,
        "transcript": "Qanengssakanka makut cuqyutekluki.",
        "translation": "I'm telling these stories as examples."
    },
    "43": {
        "startTime": 265.696,
        "endTime": 271.066,
        "transcript": "Iimteggun tangllemteggun canek elicugngaukut.",
        "translation": "We can learn things through what we see through our eyes."
    },
    "44": {
        "startTime": 271.827,
        "endTime": 282.547,
        "transcript": "Iciw' tua-i wiinga aanaka clean up-aatullrunrituq, mingqurluni tau͡gaam.",
        "translation": "You know, my mother never used to clean up, only sew."
    },
    "45": {
        "startTime": 282.557,
        "endTime": 285.797,
        "transcript": "Clean up-aararkaitalna-wa enemta ilua.",
        "translation": "It was because there was nothing to clean up in our house."
    },
    "46": {
        "startTime": 285.802,
        "endTime": 291.882,
        "transcript": "Tau͡gaam tua-i-w' ava-i qanertua Cakayiinkugni Kassaungamek-wa tua-i [?cangaktullrulli?]",
        "translation": "But I just said that at Cakayak and his spouse's, since they were Caucasian, [?they'd find things amiss?]."
    },
    "47": {
        "startTime": 291.894,
        "endTime": 295.934,
        "transcript": "Maanicetun tau͡gaam ayuqevkenateng. Phone-artaunani.",
        "translation": "But it was like it is here. There were no phones."
    },
    "48": {
        "startTime": 295.939,
        "endTime": 298.909,
        "transcript": "TV-ngqellruut-qaa?",
        "translation": "Did they have TV's?"
    },
    "49": {
        "startTime": 300.132,
        "endTime": 305.122,
        "transcript": "Taukugnek qaneryugngaunga taukugnek tamakunek elitellemnek.",
        "translation": "I speak of those, what I learned of those from them."
    },
    "50": {
        "startTime": 305.258,
        "endTime": 312.908,
        "transcript": "Elitnaullemni tuar tang camek elitellrunrilngua. Ikgetellruami-w' elitnaulqa, carraussiyaallruami.",
        "translation": "When I went to school, it seemed that I didn't learn anything. It was because my schooling was too little, too scant."
    },
    "51": {
        "startTime": 313.206,
        "endTime": 321.266,
        "transcript": "Egmian wani elitnauryuglua nangteq'nge'rma allrakunka, ikgelengraata-ll' uingetullruameng imkut.",
        "translation": "Even though I suffered wanting to go to school right away, my age, since they used to get husbands young back then."
    },
    "52": {
        "startTime": 321.271,
        "endTime": 325.511,
        "transcript": "Wiinga-am uingevkaqiitnga, ikgenateng-ll' allrakunka.",
        "translation": "They had me take a husband, and I was young."
    },
    "53": {
        "startTime": 325.52,
        "endTime": 329.35,
        "transcript": "Maani-llu marriage license-aamek piqatallmegni",
        "translation": "And when we were going to get a marriage license here"
    },
    "54": {
        "startTime": 329.359,
        "endTime": 336.689,
        "transcript": "Tauna-am commissioner-aamek aterluni marriage license-aanek cikiqengtuli.",
        "translation": "That one who issued marriage licenses was called a commissioner."
    },
    "55": {
        "startTime": 336.825,
        "endTime": 342.635,
        "transcript": "Maa-i-am iliini pilartua, \"Tauna-llam carpakayak iqlullinill'.\"",
        "translation": "Sometimes now, I say, \"That darned official lied.\""
    },
    "56": {
        "startTime": 342.973,
        "endTime": 347.393,
        "transcript": "Sixteen-aallruunga. Sixteen-aallruyugnarqua.",
        "translation": "I was 16. I think I was 16."
    },
    "57": {
        "startTime": 347.4,
        "endTime": 353.2,
        "transcript": "Marriage license-aaq-am taitesciigatnirraarluku, igarraarluku taitaa.",
        "translation": "After he said he couldn't give us the marriage license, he wrote on it and brought it."
    },
    "58": {
        "startTime": 353.211,
        "endTime": 358.871,
        "transcript": "Wiinga 18-aaruartellua marriage license-aaq wangkugnun tunlliniluku.",
        "translation": "He falsely stated that I was 18 and gave us the marriage license."
    },
    "59": {
        "startTime": 358.881,
        "endTime": 361.771,
        "transcript": "Allrakunka ilaluki.",
        "translation": "He added to my age."
    },
    "60": {
        "startTime": 362.779,
        "endTime": 367.539,
        "transcript": "Maa-i tuaggun ayagtua allrakunka, allrakuma ilamallrakun.",
        "translation": "Now, I go by that, how my age was increased."
    },
    "61": {
        "startTime": 367.546,
        "endTime": 370.846,
        "transcript": "Taumi younger-aanruyaaqua nallunailngurmek.",
        "translation": "I'm certainly younger than that."
    },
    "62": {
        "startTime": 370.858,
        "endTime": 380.828,
        "transcript": "Tau͡gaam marriage license iciw' prove-aqsugngalliniamegteggu tamakutgun kalikatgun kitugtellruit aipaqa yuunrillrani.",
        "translation": "But since, you know, they could use marriage licenses as proof, they fixed it with those documents when my spouse passed away."
    },
    "63": {
        "startTime": 381.2,
        "endTime": 384.04,
        "transcript": "Tua-i tauna qanrutkela'arqa.",
        "translation": "I talk about that."
    },
    "64": {
        "startTime": 385.384,
        "endTime": 390.884,
        "transcript": "Ilailallrulliniut-am allrakunek au͡gkut ciuqvani.",
        "translation": "Apparently, the people back then would add years in the past."
    },
    "65": {
        "startTime": 390.896,
        "endTime": 397.186,
        "transcript": "Mat'um nalliini-wa arnassaurrluni wall' angukara'urluurrluni nulirtulalria angun.",
        "translation": "These days, becoming an old woman, or a man takes a wife as an old man."
    },
    "66": {
        "startTime": 397.193,
        "endTime": 402.153,
        "transcript": "Wall' arnassagaurrluni arnaq uingaqluni mat'um nalliiini.",
        "translation": "Or a woman takes a husband as an old woman these days."
    },
    "67": {
        "startTime": 403.027,
        "endTime": 409.017,
        "transcript": "Pirkakellruat-qaa tamaani ciuliamta uum irniam wani aipangllerkaa?",
        "translation": "Back then, did our ancestors think it was important for a child to get married?"
    },
    "68": {
        "startTime": 409.027,
        "endTime": 417.247,
        "transcript": "Probably because they thought it important, my parents would have others encourage me [to marry] as well.",
        "translation": "Probably because they thought it important, my parents would have others encourage me [to marry] as well."
    },
    "69": {
        "startTime": 417.258,
        "endTime": 430.048,
        "transcript": "Atam, tamaani aipairkiutulliniit aiparkaat una yuvriraqluku ayuqucia, qaillun-llu calitacia.",
        "translation": "Look, back then, they would choose their husbands, examining their potential spouse's behavior, and how much he works."
    },
    "70": {
        "startTime": 430.85,
        "endTime": 434.72,
        "transcript": "Iciw' dumb man-amek pivkenateng.",
        "translation": "You know, they wouldn't choose a dumb man."
    },
    "71": {
        "startTime": 437.063,
        "endTime": 440.503,
        "transcript": "Mat'um-wa nalliini acirlaku \"tamian.\"",
        "translation": "These days, I should name it \"tamian\" [dumb man]."
    },
    "72": {
        "startTime": 440.788,
        "endTime": 446.428,
        "transcript": "Ilii uingelartuq, uinga-ll' taun' canermek nalluluni.",
        "translation": "Some take husbands, and their husband doesn't know how to do anything."
    },
    "73": {
        "startTime": 446.664,
        "endTime": 450.274,
        "transcript": "Iqlunritua. Iqluunga-qaa?",
        "translation": "I'm not lying. Am I lying?"
    },
    "74": {
        "startTime": 450.45,
        "endTime": 456.15,
        "transcript": "Wall' angun nulirturaqluni. Tua-i tua-i.",
        "translation": "Or a man takes a [kazy] wife. There you have it."
    },
    "75": {
        "startTime": 456.163,
        "endTime": 462.103,
        "transcript": "Wiinga wani qanrutkenrilnguarngaitanka makut piciulriit.",
        "translation": "I will not keep from talking about these true things."
    },
    "76": {
        "startTime": 462.902,
        "endTime": 466.882,
        "transcript": "Wiinga uikarcullrulliniagnga angayuqaagma.",
        "translation": "Apparently, my parents sought a husband for me."
    },
    "77": {
        "startTime": 466.91,
        "endTime": 475.43,
        "transcript": "Au͡gna-am uikaqa cunaw' ayagyuaqtarluni caneq elisngaq'apiarluku. Nick, Nick O'Nick.",
        "translation": "It turned out that my groom to be was young and was an expert in doing things. Nick, Nick O'Nick."
    },
    "78": {
        "startTime": 477.223,
        "endTime": 480.123,
        "transcript": "Aipaqsagutaqa-llu young-apiallrulliniuq.",
        "translation": "And when I married him, he was very young."
    },
    "79": {
        "startTime": 480.138,
        "endTime": 488.378,
        "transcript": "Marriage license-aamegni allrakurlunuk Nick-aa 22, wiinga-llu 18 married-aallemegni.",
        "translation": "On our marriage license, our ages were, Nick 22, and me 18, when we got married."
    },
    "80": {
        "startTime": 489.21,
        "endTime": 498.68,
        "transcript": "Waten pilallruanga aanama: qessavkenii-gguq tauna pikilaku. \"Castekaqerput.\"",
        "translation": "My mother used to tell me this: I should work with him without being lazy. \"He will provide for us.\""
    },
    "81": {
        "startTime": 499.413,
        "endTime": 502.403,
        "transcript": "Taum-gguq uima cascirciqaakut.",
        "translation": "She said my husband will provide for us."
    },
    "82": {
        "startTime": 502.409,
        "endTime": 507.969,
        "transcript": "Una-wa anngaqa TB-rluni tua-i assiirulluni cayuunani.",
        "translation": "My older brother got impaired with TB and couldn't do anything."
    },
    "83": {
        "startTime": 508.076,
        "endTime": 518.746,
        "transcript": "Tua-i taumek-ll' anngamnek umyuarniulallruama, tua-i tuqukan-llu... tang umyuarteqtullrullinilriakut wangkuta.",
        "translation": "And because I would be worried about my older brother, and when he dies... you see, we would ponder."
    },
    "84": {
        "startTime": 518.756,
        "endTime": 523.226,
        "transcript": "Allrakunka-am ikgelengraata umyuarteq'lallrullinilrianga.",
        "translation": "Though I was young, I'd ponder [upon such things]."
    },
    "85": {
        "startTime": 523.232,
        "endTime": 532.232,
        "transcript": "Umyuarteqaqlua-ll' waten: taum-am anngarma nulirran, \"Pikina,\" qarutelaanga.",
        "translation": "And I'd think like this: my older brothers wife, \"Do it, okay,\" because she encouraged me."
    },
    "86": {
        "startTime": 532.972,
        "endTime": 542.012,
        "transcript": "Tua-i-ll' umyuarteq'langua waten pingaitniaqlua, kenkiama allamek love-arlua.",
        "translation": "Then I started thinking like this, that I wouldn't, because I loved someone else, being in love."
    },
    "87": {
        "startTime": 542.264,
        "endTime": 551.294,
        "transcript": "Tua-i-w' mat'um nalliini ap[qiitnek] qanrutekciqlikeka allamek loving-aarlua.",
        "translation": "As [they] say these days, I'd probably say that I was loving another."
    },
    "88": {
        "startTime": 551.494,
        "endTime": 556.354,
        "transcript": "Assiqtarluni tauna alla. Wii tang tua-i kenkaqluku.",
        "translation": "That other one was attractive. You see, I loved him."
    },
    "89": {
        "startTime": 556.364,
        "endTime": 562.064,
        "transcript": "Una tau͡gken uikaqa meet-aqallrukenaku takaqluku.",
        "translation": "Without having met my groom to be, however, I was intimidated by him."
    },
    "90": {
        "startTime": 562.507,
        "endTime": 571.207,
        "transcript": "Tua-i-ll' tuani aanama tang tua-i pilaanga-ll' uum, \"Castekaqerput. Tang castekarput tauna casciigalnguq.\"",
        "translation": "Then because my mother, you see, would say to me, \"He will proved for us. Look, our provider there can't do anything.\""
    },
    "91": {
        "startTime": 571.412,
        "endTime": 573.182,
        "transcript": "Iliini tang...",
        "translation": "Sometimes, you see..."
    },
    "92": {
        "startTime": 573.19,
        "endTime": 579.5,
        "transcript": "Waten-llam pilallrukaitkut: aqumluta-gguq atam umyuartequraqa'aqluta.",
        "translation": "They'd also tell us this: we should sit down and ponder for a while."
    },
    "93": {
        "startTime": 579.51,
        "endTime": 581.43,
        "transcript": "Wiinga atulallrulliniaqa.",
        "translation": "I would do that."
    },
    "94": {
        "startTime": 581.445,
        "endTime": 592.865,
        "transcript": "Iliini tang umyuarteqeqcaarnaurtua waten: \"Ingna-llam anngaqa tuqukan pisqestek'lalqa umyuarniurciqua.\"",
        "translation": "Sometimes, you see, I'd ponder like this: \"If my older brother over there who'd tell me what to do dies, I will regret it.\""
    },
    "95": {
        "startTime": 592.877,
        "endTime": 600.227,
        "transcript": "Iciw' tua-i umyuarniuryaraq-llu nalluveknaki 16, nasaurlullraulua.",
        "translation": "You know, I already know how to worry at 16, as a little girl."
    },
    "96": {
        "startTime": 600.229,
        "endTime": 602.699,
        "transcript": "Ceńirtaarteńgulua.",
        "translation": "I'd go out to visit a lot."
    },
    "97": {
        "startTime": 602.704,
        "endTime": 608.154,
        "transcript": "Tuaten tang umyuarteqnaurtua. Tua-i-ll' caqerlua angerlua.",
        "translation": "You see, I would think like that. Then one day, I agreed."
    },
    "98": {
        "startTime": 609.434,
        "endTime": 614.904,
        "transcript": "Aren, maaten tua-i aipaqsagutaqa tang aipaqa takaqluku.",
        "translation": "Oh my, when I married him, you see, I was intimidated by my spouse."
    },
    "99": {
        "startTime": 615.991,
        "endTime": 620.461,
        "transcript": "Inartaqlua waten aklutuumarma caniani.",
        "translation": "I'd go to bed fully clothed like this beside him."
    },
    "100": {
        "startTime": 620.997,
        "endTime": 626.547,
        "transcript": "Iciw' u͡gayarluten maa-i gown-arluteng caluteng inartelallinilriit.",
        "translation": "You know, they apparently undress and put on gowns or something to go to bed."
    },
    "101": {
        "startTime": 626.556,
        "endTime": 631.886,
        "transcript": "Aklutuumarma wii inarrnaurtua caniani taum aipama.",
        "translation": "I'd go to bed fully clothed next to my spouse."
    },
    "102": {
        "startTime": 631.961,
        "endTime": 633.371,
        "transcript": "Atang...",
        "translation": "You see..."
    },
    "103": {
        "startTime": 633.409,
        "endTime": 642.059,
        "transcript": "Ilamnun-am uani uanlata, kiani-ll' taukut uika tua-i kiani, kiugumi village-arrarmi.",
        "translation": "To my family downriver since they were downriver, and my husband upriver, upriver in a little village."
    },
    "104": {
        "startTime": 642.068,
        "endTime": 643.858,
        "transcript": "Iciw' piani avtaalriit.",
        "translation": "You know, they split inland."
    },
    "105": {
        "startTime": 643.86,
        "endTime": 649.85,
        "transcript": "Ilamnun anelrarqama meglartua, iciw' utercuumiinii.",
        "translation": "When I'd go downriver to my family, I'd be reluctant to go back, you know, I wouldn't want to return."
    },
    "106": {
        "startTime": 649.864,
        "endTime": 653.404,
        "transcript": "Aanama pingnauraanga, \"Ampi uterten.\"",
        "translation": "My mother would end up saying to me, \"Go home already.\""
    },
    "107": {
        "startTime": 653.648,
        "endTime": 661.128,
        "transcript": "Tua-i taqsuq'ngaqama anlua. Umyuaqa-w' tua-i Kass'at apqiitnek smash.",
        "translation": "When I'd get tired, I'd go out. My mindset was, as they say in English, smash[ed]."
    },
    "108": {
        "startTime": 661.337,
        "endTime": 665.137,
        "transcript": "Itra'urlulalrianga taukunun uimnun.",
        "translation": "Pity me, I'd go upriver to my husband's."
    },
    "109": {
        "startTime": 665.194,
        "endTime": 676.384,
        "transcript": "Iteryartuarnaurtua tang nepa'itqapiarluni. Iternaurtua ak'a inartellrullin[ilria]. Takaipaa-ll' wangni. Takaitellrullinivaa.",
        "translation": "I'd start going in, you see, to absolute silence. I'd go in and he'd already be in bed. I was so shameless. I was so shameless."
    },
    "110": {
        "startTime": 676.561,
        "endTime": 685.251,
        "transcript": "Tua-i-ll' tua-i nallunrilamku waniw' aipaqa inangqiin canianun tua-i aklutuumarma-ll' inarrlua.",
        "translation": "Then since I knew my spouse was lying here, I went to bed fully clothed beside him."
    },
    "111": {
        "startTime": 685.361,
        "endTime": 689.481,
        "transcript": "Aren, aipaqsagutellemni-ll' tua-i aqviitnga itertua tang...",
        "translation": "Oh my, when I married him and they got me, I went in, you see..."
    },
    "112": {
        "startTime": 689.489,
        "endTime": 699.119,
        "transcript": "Mat'um nalliini angun nulirtulartuq camek-llu tauna arnani cikirpek'naku, aipaa.",
        "translation": "These days, a man takes a wife and doesn't give anything to his wife."
    },
    "113": {
        "startTime": 699.377,
        "endTime": 702.857,
        "transcript": "Maaten tang itertua, ak'a pitullruyugnarqut.",
        "translation": "I went in, you see, I think they used to do it long ago."
    },
    "114": {
        "startTime": 702.86,
        "endTime": 707.11,
        "transcript": "Ukuk tang yassigpallraak kalikaak.",
        "translation": "You see, there were these two huge cardboard boxes."
    },
    "115": {
        "startTime": 707.126,
        "endTime": 714.586,
        "transcript": "Tua-i-ll' tang au͡g'um nasaurluum taum uima anngaan yua, tuaken tang anciaqluni.",
        "translation": "Then,you see, that girl, my husband's older brother's child, would take things out from there."
    },
    "116": {
        "startTime": 714.596,
        "endTime": 723.116,
        "transcript": "Taum aaniita, \"Tang tua-i ingleten.\" Ingelret tang au͡gkut aklukegtaarait ulikegtaaraat nutararrlainaat.",
        "translation": "Their mother [said], \"Look, there's your bed.\" The bed, you see, was good things, good blankets, all new."
    },
    "117": {
        "startTime": 723.126,
        "endTime": 726.906,
        "transcript": "Tua-i beginning-aaqatarlua.",
        "translation": "I was going to start the beginning."
    },
    "118": {
        "startTime": 727.798,
        "endTime": 731.488,
        "transcript": "Tuaten pitullruut aklirluki.",
        "translation": "They used to give them things like that."
    },
    "119": {
        "startTime": 731.498,
        "endTime": 737.598,
        "transcript": "Tuaken tang kalikagnek taum nasaurluum cikirtungkilia canek.",
        "translation": "You see, that girl would give me things from those cardboard [boxes]."
    },
    "120": {
        "startTime": 737.605,
        "endTime": 743.235,
        "transcript": "Cikiraanga-llam anciluni atkugmek, fur parka.",
        "translation": "She took out and gave me an atkuk, [a] fur parka."
    },
    "121": {
        "startTime": 743.248,
        "endTime": 747.518,
        "transcript": "Iciw' mat'um nalliini fur parka-t expensive.",
        "translation": "You know, these days, fur parkas are expensive."
    },
    "122": {
        "startTime": 747.56,
        "endTime": 750.17,
        "transcript": "Takarnaqluteng.",
        "translation": "They were overwhelming."
    },
    "123": {
        "startTime": 750.187,
        "endTime": 756.107,
        "transcript": "Atkugmek-am cikiqilia. Canimnun-llu elliluku tua-i wii quyavkenii.",
        "translation": "She gave me a parka. And she put it by me, but I wasn't thankful."
    },
    "124": {
        "startTime": 756.117,
        "endTime": 759.377,
        "transcript": "Iciw' tua-i uingyuumiicaaqngama.",
        "translation": "You know, because I didn't want to take a husband."
    },
    "125": {
        "startTime": 759.384,
        "endTime": 766.074,
        "transcript": "Cali-am pirraarluni anciuq piluguuk, fur mukluks.",
        "translation": "After that, she also took out piluguuk, fur mukluks."
    },
    "126": {
        "startTime": 766.531,
        "endTime": 769.151,
        "transcript": "Tegulukek canimnun ellilukek.",
        "translation": "I took them and put them beside me."
    },
    "127": {
        "startTime": 769.163,
        "endTime": 774.623,
        "transcript": "Tang carugaat. Tuaten pilua.",
        "translation": "You see, there were many things. [S]he gave them to me like that."
    },
    "128": {
        "startTime": 775.952,
        "endTime": 777.652,
        "transcript": "Tua-i.",
        "translation": "There you have it."
    },
    "129": {
        "startTime": 778.244,
        "endTime": 784.854,
        "transcript": "Tua-i-llu aipaqa tuani ilamini tuaten pillrunrituq.",
        "translation": "Then my spouse didn't do that there in his family's home."
    },
    "130": {
        "startTime": 785.382,
        "endTime": 790.772,
        "transcript": "Uksuarmi tegullruatnga. Up'nerkaquani ilamnun-am meglua.",
        "translation": "They took me in the fall. The next spring, I didn't want to go back with my family."
    },
    "131": {
        "startTime": 790.783,
        "endTime": 793.343,
        "transcript": "Tua-i tuaten pilallruunga.",
        "translation": "I used to do that."
    },
    "132": {
        "startTime": 793.356,
        "endTime": 800.906,
        "transcript": "Megngama-ll' tua-i taum aiparma upaucugyaaqlua up'nerkillernun. Pingaunii.",
        "translation": "And when I didn't want to go back, my spouse wanted to move with me to a spring camp. I wouldn't."
    },
    "133": {
        "startTime": 800.912,
        "endTime": 803.932,
        "transcript": "Unillua tayim' ayagluni.",
        "translation": "He left me and went."
    },
    "134": {
        "startTime": 804.532,
        "endTime": 809.582,
        "transcript": "Tua-i-llu tua-i wii angnirilua ilamni.",
        "translation": "Then I got happier with my family."
    },
    "135": {
        "startTime": 809.596,
        "endTime": 819.236,
        "transcript": "Tekilluni up'nerkami ukut qanertut, tauna-gguq, taum-gguq uima ullakataraanga move-arluni family-mnun.",
        "translation": "When he arrived in the spring, these people said that my husband was going to come to me and move in with my family."
    },
    "136": {
        "startTime": 819.242,
        "endTime": 824.752,
        "transcript": "Tua-i tuaten pillrani wiinga iciw' quyalua.",
        "translation": "When he did that, I was, you know, thankful."
    },
    "137": {
        "startTime": 824.761,
        "endTime": 829.191,
        "transcript": "Ima tanem aanama pilallrukiinga, \"Castekaqerput.\"",
        "translation": "Now again, my mother used to say to me, \"He'll be our provider.\""
    },
    "138": {
        "startTime": 829.2,
        "endTime": 833.21,
        "transcript": "Tua-i-w' move-arluni tailuni waniw' aulukqataqiikut.",
        "translation": "He was going to come and move to take care of us."
    },
    "139": {
        "startTime": 833.228,
        "endTime": 842.408,
        "transcript": "Tuaten tua-i nallunrilama iciw' tua-i assirluku tang imkunga'arrluku, tunusngaurluku-ll' uitalallruama.",
        "translation": "Since I knew that, you know, I started [treating] him well, also because I used to always have my back turned to him."
    },
    "140": {
        "startTime": 842.641,
        "endTime": 849.051,
        "transcript": "Iliini-ll' tua-i tangerrsaurrluku. Takarnaqpiarluni.",
        "translation": "And I started looking at him sometimes. He was very intimidating."
    },
    "141": {
        "startTime": 849.065,
        "endTime": 853.965,
        "transcript": "Takaqutetullrulliut. Wiinga-w' tuaten pillrulrianga.",
        "translation": "They may have been reserved around each other. I did that."
    },
    "142": {
        "startTime": 854.103,
        "endTime": 857.993,
        "transcript": "Tua-i-llu move-arluni wangkutnun.",
        "translation": "Then he moved in with us."
    },
    "143": {
        "startTime": 858.452,
        "endTime": 866.742,
        "transcript": "Aren-llam qinganrilngua egmian agturcecuilama tuaten inartelaama ellaka man'a eqluku.",
        "translation": "Oh my, I also didn't get pregnenat right away because I wouldn't let him touch me, and would go to bed and shut out the world."
    },
    "144": {
        "startTime": 866.866,
        "endTime": 874.276,
        "transcript": "Iliini-llu unuakumi aanama pilaraanga waten: \"Yagleralanrilu.\"",
        "translation": "And some mornings, my mother would say this to me: \"Don't harshly raise your hand.\""
    },
    "145": {
        "startTime": 874.28,
        "endTime": 881.19,
        "transcript": "Aipaagni tang... iciw' angutet nallunritut arnat yagiratulliut qaillun.",
        "translation": "Probably, you see... you know, men know that women raise their hands a certain way."
    },
    "146": {
        "startTime": 881.438,
        "endTime": 890.798,
        "transcript": "Iliini waten tallini taitaqaku wiinga waten assiilkelluku piaqluku.",
        "translation": "Sometimes, when he brought his arm like this, I would do this out of dislike."
    },
    "147": {
        "startTime": 890.804,
        "endTime": 895.124,
        "transcript": "Aanama, \"Piyuitut tuaten.\" Nalluama-wa.",
        "translation": "My mother [said to me], \"They don't do that.\" It was because I didn't know."
    },
    "148": {
        "startTime": 899.166,
        "endTime": 902.046,
        "transcript": "Rule-angqelliniut cat tamarmeng.",
        "translation": "Evidently, everything has rules."
    },
    "149": {
        "startTime": 902.257,
        "endTime": 904.757,
        "transcript": "Piyuitut-gguq tuaten.",
        "translation": "She said they don't do that."
    },
    "150": {
        "startTime": 904.949,
        "endTime": 909.949,
        "transcript": "Angun-gguq nulirtulartuq naanguarkaminek.",
        "translation": "She said a man takes a wife to fool around with her."
    },
    "151": {
        "startTime": 910.327,
        "endTime": 913.247,
        "transcript": "Tua-i alingallagnaurtua.",
        "translation": "I would get scared."
    },
    "152": {
        "startTime": 913.264,
        "endTime": 917.764,
        "transcript": "Tua-i-ll' tang qingarlua Robert Nick, yuukamek pia-i.",
        "translation": "Then, you see, I was pregnant with Robert Nick, my child to be inland."
    },
    "153": {
        "startTime": 917.775,
        "endTime": 925.475,
        "transcript": "Qinganglua. Qingangellemni tang nutaan uika tauna cauluku-ll' caumayaurtellrukeka.",
        "translation": "I got pregnant. When I got pregnant, you see, I finally started facing my husband face to face."
    },
    "154": {
        "startTime": 926.207,
        "endTime": 930.257,
        "transcript": "Aspiallinivaa-ll' Nick-ami.",
        "translation": "Nick is so wonderful."
    },
    "155": {
        "startTime": 930.893,
        "endTime": 938.753,
        "transcript": "Tua-i-llam tuaten qinganglua nutaan murilkessaurtellruaqa Bible-aanek, Bible.",
        "translation": "Then when I got pregnant like that, I finally observed him [with] a Bible."
    },
    "156": {
        "startTime": 938.89,
        "endTime": 944.1,
        "transcript": "Una tang tauna uika calilgupiaq.",
        "translation": "You see, my husband was always busy."
    },
    "157": {
        "startTime": 944.392,
        "endTime": 951.402,
        "transcript": "Tua-i cunaw' hard worker-aarulliniami angayuqaagma cucukellrak.",
        "translation": "It turned out that it was because my parents' choice was a hard worker."
    },
    "158": {
        "startTime": 952.877,
        "endTime": 959.697,
        "transcript": "Bible-aaliurturyaur[tuq]. Bible-aanek-am naaqiurnaurtuq every evening.",
        "translation": "[He] started always reading the Bible. He would always read the Bible every evening."
    },
    "159": {
        "startTime": 960.924,
        "endTime": 966.294,
        "transcript": "Malruurtuk-ll' irniapuk, Robert, Margaret, piyugnarquq.",
        "translation": "Then we had two children, Robert, Margaret, I think."
    },
    "160": {
        "startTime": 966.312,
        "endTime": 969.842,
        "transcript": "Pastor-aarurrluni young.",
        "translation": "He became a pastor [at a] young [age]."
    },
    "161": {
        "startTime": 970.87,
        "endTime": 976.94,
        "transcript": "Aspialliniuq. Qaneryugngaunga assillranek.",
        "translation": "He turned out to be wonderful. I can say how good he was."
    },
    "162": {
        "startTime": 977.446,
        "endTime": 981.856,
        "transcript": "Aquiyuunani. Aquilallruukut.",
        "translation": "He wouldn't play out. We used to play out."
    },
    "163": {
        "startTime": 981.861,
        "endTime": 987.201,
        "transcript": "Maa-i aquivigtangqertuq like Teen Center, allat-llu.",
        "translation": "Now, there are places to play like [the] Teen Center, and others."
    },
    "164": {
        "startTime": 987.512,
        "endTime": 992.562,
        "transcript": "Aquilallemni-ll' tauna uikaqa tangerqayuunaku.",
        "translation": "And when I'd go play, I'd never see my groom to be."
    },
    "165": {
        "startTime": 993.32,
        "endTime": 1000.31,
        "transcript": "Tuaten tang ayagmek ayuqellinian angayuqaagma pikesqellrullinikiik.",
        "translation": "You see, since he was like that from the beginning, my parents wanted me to have him."
    },
    "166": {
        "startTime": 1001.133,
        "endTime": 1011.193,
        "transcript": "Bible-aaliurturyaurrluni-am tua-i. Ak'anivkenaku-ll' pastor-aarurrluni. Young-arluni pastor-aarurtellruuq Nunapicuarmi.",
        "translation": "He started always reading the Bible. And not long after, he became a pastor. He became a pastor at a young age in Nunapitchuk."
    },
    "167": {
        "startTime": 1011.302,
        "endTime": 1015.622,
        "transcript": "Ava-i-ll' tua-i pastor-aaruinanermini tuquluni.",
        "translation": "And recently, he died while he was a pastor."
    },
    "168": {
        "startTime": 1015.636,
        "endTime": 1019.296,
        "transcript": "Nine, nine-aanek-ll' irnianglunuk.",
        "translation": "And he had nine children."
    },
    "169": {
        "startTime": 1019.637,
        "endTime": 1023.527,
        "transcript": "Angli-ll' tang tuaten piyullrullinivaa.",
        "translation": "Wow, you see, he had such passion for that."
    },
    "170": {
        "startTime": 1023.767,
        "endTime": 1030.117,
        "transcript": "Pastor-aarinanermini-ll' ping'umek kipusviggarmek pililuni.",
        "translation": "And while he was a pastor, me made that little trading post inland."
    },
    "171": {
        "startTime": 1030.12,
        "endTime": 1041.44,
        "transcript": "Pilivailegmi ciumek agayulirtet, Moravian-aat agayulirtait ullagnillrui, Kuigglugmi-llu-gguq cali agayulirta ullagluku.",
        "translation": "Before makiung it, he said he first went to the priests, the Moravian priests, and he said he also went to the priest in Kwethluk."
    },
    "172": {
        "startTime": 1043.811,
        "endTime": 1049.431,
        "transcript": "Nallunritqapiaq elitna'ungssagaunani-ll'.",
        "translation": "He was very knowledgeable, and he had absolutely no schooling."
    },
    "173": {
        "startTime": 1050.281,
        "endTime": 1058.831,
        "transcript": "Apqaullinii-am tamakut pastor-aarinenermini kipusvik inglukluku calillerkaminek.",
        "translation": "Apparently, he asked them about working along with the trading post while he was a pastor."
    },
    "174": {
        "startTime": 1058.84,
        "endTime": 1062.05,
        "transcript": "Tamakut-llu tua-i okay-lliniluku.",
        "translation": "And they gave him the okay."
    },
    "175": {
        "startTime": 1062.068,
        "endTime": 1072.828,
        "transcript": "Tamakunun tau͡gaam ellangcarraarluni pia-i pingna piliaruuq, Nick O'Nick Trading Post, agayulirteńun makunun elisngalrianun.",
        "translation": "That [place] inland was made only after being advised by those, Nick O'Nick Trading Post, these knowledgeable priests."
    },
    "176": {
        "startTime": 1074.573,
        "endTime": 1077.493,
        "transcript": "Tua-i tuaten ayuqlunuk.",
        "translation": "That's what we were like."
    },
    "177": {
        "startTime": 1082.617,
        "endTime": 1090.159,
        "transcript": "Tua-i-ll' ava-i tuaten irniapuk anglicarluki.",
        "translation": "Then we raised our children like that."
    },
    "178": {
        "startTime": 1091.204,
        "endTime": 1096.254,
        "transcript": "Taangaq-ll' ataucirquungraan waten piksaunaku.",
        "translation": "And he never did this even once with alcohol."
    },
    "179": {
        "startTime": 1096.265,
        "endTime": 1102.955,
        "transcript": "Akmavet ayalallruukuk qavcirqunek kipusvingumariluku.",
        "translation": "We went [to the city] over there several times after he'd gotten his trading post."
    },
    "180": {
        "startTime": 1105.258,
        "endTime": 1113.628,
        "transcript": "Elitna'ungssagaileng'e'rmi ilii smart-apialliniuq, elisngaq'apiarararkauluni.",
        "translation": "Though some have absolutely no schooling, they are very smart, will be very knowledgeable."
    },
    "181": {
        "startTime": 1113.783,
        "endTime": 1120.023,
        "transcript": "Waniw' wiinga nanrarpek'naku cuqyutkuurluku qalartua.",
        "translation": "Now, I am not praising him, but speaking with him as an example."
    },
    "182": {
        "startTime": 1122.466,
        "endTime": 1131.446,
        "transcript": "Akmavet ayalallmegni Kass'at mat'um nalliini yugnikutek'lalliniat taangarraq.",
        "translation": "When we'd go over there, Caucasians these days apparently use a little alcohol to make friends."
    },
    "183": {
        "startTime": 1131.698,
        "endTime": 1136.578,
        "transcript": "Tua-i una-ll' itran, \"You want drink?\"",
        "translation": "Then when this person comes in, \"You want [a] drink?\""
    },
    "184": {
        "startTime": 1137.963,
        "endTime": 1147.223,
        "transcript": "Akmani business-aalegni calillgutaini tarritelallruukuk.",
        "translation": "Over there, we'd walk among his fellow workers with businesses."
    },
    "185": {
        "startTime": 1147.231,
        "endTime": 1153.621,
        "transcript": "Tua-i-ll' igvaamnuk tua-i arenqiaqaarluni, \"Nick, you want drink?\" pilallruat.",
        "translation": "Then when we appeared, after he was struggling, \"Nick you want [a] drink?\" they'd say to him."
    },
    "186": {
        "startTime": 1153.636,
        "endTime": 1160.236,
        "transcript": "\"No.\" No-raqan atam sorry-lalriit imkut elisngapiat.",
        "translation": "\"No.\" When he said \"no,\" those very knowledgeable people would say \"sorry.\""
    },
    "187": {
        "startTime": 1160.778,
        "endTime": 1163.048,
        "transcript": "\"I'm sorry, Nick.\"",
        "translation": "\"I'm sorry, Nick.\""
    },
    "188": {
        "startTime": 1163.049,
        "endTime": 1167.949,
        "transcript": "Pirraarluku kinguneq taqluku, \"Nick, you're lucky.\"",
        "translation": "Then after saying that, they'd end with: \"Nick, you're lucky.\""
    },
    "189": {
        "startTime": 1168.405,
        "endTime": 1171.075,
        "transcript": "Tuaten-llu piaqluku.",
        "translation": "And they'd say that to him."
    },
    "190": {
        "startTime": 1171.474,
        "endTime": 1177.904,
        "transcript": "Qalarutkanka makut qanenrilnguarngailama assilriaruat",
        "translation": "I'm speaking of these because I will not hold back speaking of them since they're good."
    },
    "191": {
        "startTime": 1178.613,
        "endTime": 1181.733,
        "transcript": "Tua-i tuaten ayaglunuk.",
        "translation": "That's how we went [through life]."
    },
    "192": {
        "startTime": 1182.598,
        "endTime": 1192.208,
        "transcript": "Au͡gna-am kipusvingellra kiturlaku. Canrituq. Qaillun, iliini qanrutkeciqaqa qaillun.",
        "translation": "His tradin gpost, let me skip it. It's okay. Somehow, I'll speak about it sometime somehow."
    },
    "193": {
        "startTime": 1192.218,
        "endTime": 1199.908,
        "transcript": "Caliyuitellruuq Nick-aq. Nani-llu work-aqayuunani.",
        "translation": "Nick never used to work. And he didn't work anywhere."
    },
    "194": {
        "startTime": 1199.914,
        "endTime": 1203.664,
        "transcript": "Fur hunter-aarulliniluni tua-i, fur hunter.",
        "translation": "He was a fur hunter, [a] fur hunter."
    },
    "195": {
        "startTime": 1203.846,
        "endTime": 1206.586,
        "transcript": "Melqulegcurteńguluni.",
        "translation": "He was a fur hunter."
    },
    "196": {
        "startTime": 1206.59,
        "endTime": 1212.38,
        "transcript": "Tua-i-llu pia-i trading post-ani tamakukun ayagnillrua.",
        "translation": "Then, he stated his trading post inland with that."
    },
    "197": {
        "startTime": 1212.397,
        "endTime": 1217.057,
        "transcript": "Qanellrulartuq waten, nalluyagucuitanka ilait qanellri wangnun:",
        "translation": "He used to say this, I never forget some of what he said to me:"
    },
    "198": {
        "startTime": 1217.065,
        "endTime": 1224.785,
        "transcript": "Taum-gguq nalliini melqulegtani tunellrui maani, fur buyer-aanun-wa pillikai.",
        "translation": "He said that at that time, he sold his fur here, probably to fur buyers."
    },
    "199": {
        "startTime": 1225.26,
        "endTime": 1230.51,
        "transcript": "Seven hundred-llu-gguq akingluni, akingluteng.",
        "translation": "He said he got $700 for them."
    },
    "200": {
        "startTime": 1230.524,
        "endTime": 1236.334,
        "transcript": "Tua-i-ll' tauna aturluku carrarnek tekiulluni.",
        "translation": "Then using that, he arrived with little things."
    },
    "201": {
        "startTime": 1236.379,
        "endTime": 1238.649,
        "transcript": "Tamana call' kiturlaku?",
        "translation": "Can I skip that too?"
    },
    "202": {
        "startTime": 1238.65,
        "endTime": 1249.37,
        "transcript": "Tau͡gaam makut irniaput angayuqrit teacher-aarulliniut.",
        "translation": "But our children's parents were apparently teachers."
    },
    "203": {
        "startTime": 1250.096,
        "endTime": 1255.826,
        "transcript": "Arnam panian, ayuqsugngaa panian arnaq.",
        "translation": "A woman's daughter, a woman's daughter can be like her."
    },
    "204": {
        "startTime": 1255.838,
        "endTime": 1261.638,
        "transcript": "Angun-llu cali qetunraan tangvaurluku callra ayuqsugngaa.",
        "translation": "And a man's son can watch him and do what he does."
    },
    "205": {
        "startTime": 1262.393,
        "endTime": 1269.613,
        "transcript": "Ukut waniwa angutet yum'a atateng ayuqenritaat.",
        "translation": "My male children here are not like their father."
    },
    "206": {
        "startTime": 1270.809,
        "endTime": 1274.229,
        "transcript": "Iqlunritua. Qanrutkaqa iqluvkenii.",
        "translation": "I'm not lying. I'm speaking of it without lying."
    },
    "207": {
        "startTime": 1274.232,
        "endTime": 1285.882,
        "transcript": "Ping'um tau͡gaam pia-i anngamta alerquutni-w' tua-i atuamiu pia-i piqacaarqii pingna, pilallikii.",
        "translation": "But our eldest brother over there, because he adheres to his traditional instructions, is working at [the trading post] inland, probably."
    },
    "208": {
        "startTime": 1285.896,
        "endTime": 1288.716,
        "transcript": "Qaillun nalluaqa ayuqucia.",
        "translation": "I don't know what he's like."
    },
    "209": {
        "startTime": 1289.072,
        "endTime": 1294.782,
        "transcript": "Tau͡gaam assikpiaraqa wii tauna anngarput. Aspiartuq atam.",
        "translation": "But I really like our older brother. He's wonderful, you see."
    },
    "210": {
        "startTime": 1295.343,
        "endTime": 1298.313,
        "transcript": "Care-araakut atam.",
        "translation": "He cares for us, you see."
    },
    "211": {
        "startTime": 1298.805,
        "endTime": 1303.225,
        "transcript": "Brothers and sisters-aani-ll' care-apiarluki.",
        "translation": "And he takes great care of his brothers and sisters."
    },
    "212": {
        "startTime": 1303.287,
        "endTime": 1313.837,
        "transcript": "Nanrarpek'naku qanrutkaqa family-t qaillun raise-allrat ayuqenritellra irniat-llu pitekluku.",
        "translation": "Without praising him, I'm speaking of him to show how families are raised differently, and children."
    },
    "213": {
        "startTime": 1314.784,
        "endTime": 1325.714,
        "transcript": "Tua-i man'a arcaqerluku enemek clean up-aarillerkaq tua-i tang umyuamni uitapialallrulria uumirpak waten piqataama.",
        "translation": "This cleaning up the home was especially prevalent in my mind lately as I was going to [be interviewed] like this."
    },
    "214": {
        "startTime": 1328.003,
        "endTime": 1336.448,
        "transcript": "Tamana-llu erurarkat kenilriit arnam, nasaurluum aanani...",
        "translation": "And those dishes and what to cook, a woman, a girl, [?] her mother..."
    }
};